var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoHeaderCollinson = function SvgLogoHeaderCollinson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 192 192"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "#fff",
    rx: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE0058",
    fillRule: "evenodd",
    d: "M164.153 63.278C151.406 41.31 125.913 26 96.393 26c-7.714 0-15.43.998-22.138 2.995 22.475 1.997 41.93 15.31 52.329 34.283z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#96172E",
    fillRule: "evenodd",
    d: "M92.68 55.58c-6.7-4.004-14.406-6.006-22.446-6.006C44.772 49.574 24 70.263 24 95.624c0 25.361 20.772 46.05 46.234 46.05 8.04 0 15.746-2.336 22.446-6.006-17.756-4.672-31.157-20.69-31.157-40.044 0-19.354 13.4-35.705 31.157-40.043",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E89CAE",
    fillRule: "evenodd",
    d: "M78.72 162.782c6.71 1.674 14.424 3.013 22.139 3.013 29.519 0 55.013-15.399 67.76-37.827h-37.57c-10.398 19.081-29.854 32.471-52.328 34.814",
    clipRule: "evenodd"
  })));
};
export default SvgLogoHeaderCollinson;